import { useAuth0 } from '@auth0/auth0-react';
import { useContext } from 'react';
import { useCallback } from 'react';
import { Localization } from '../../model/store/providers/Localization';
import { Referrer } from '../../model/store/providers/Referrer';
import { LocalSystemFilter } from '../../model/store/providers/LocalSystemFilter';
import './LoginPage.scss';
import { resourcesBaseUri } from '../../config';

const LoginPage = () => {
	const { referrerLabel, referrerUrl } = useContext(Referrer.State);
	const { enabledLocalSystems } = useContext(LocalSystemFilter.State);
	const { language, translations } = useContext(Localization.State);
	const { loginWithRedirect } = useAuth0();
	const ui_locales = language || undefined;
	const onClick = useCallback(() => {
		loginWithRedirect({
			appState: {
				referrerLabel,
				referrerUrl,
				enabledLocalSystems,
				language
			},
			ui_locales
		})
	}, [loginWithRedirect, referrerLabel, enabledLocalSystems, referrerUrl, language, ui_locales]);
	const { appName, signInPage: { signInBtn }} = translations;

	return (
		<div className="login-page">
			<div className="login-page__header">
				<img src={`${resourcesBaseUri}/rblogo-trans.png`} className="login-page__logo" alt="logo" />
				<h1>{appName}</h1>
			</div>
			<div className="login-page__body">
				<button
					className="login-page__login-btn "
					onClick={onClick}
				>
					{signInBtn}
				</button>
			</div>
		</div>
	)
}

export default LoginPage;